{
  "note": "made by tools/make-platform.py from assets/platform; do not edit",
  "image": "/sprites/platform.png",
  "size": [
    1672,
    941
  ],
  "aspect": 1.7768,
  "led": {
    "x": 0.4115,
    "y": 0.271,
    "w": 0.3343,
    "h": 0.0956
  },
  "ledBoard": {
    "x": 0.3977,
    "y": 0.2465,
    "w": 0.3618,
    "h": 0.1445
  },
  "board": {
    "x": 0.878,
    "y": 0.4846,
    "w": 0.1011,
    "h": 0.135
  },
  "sign": {
    "x": 0.7955,
    "y": 0.4198,
    "w": 0.0514,
    "h": 0.102
  },
  "doors": {
    "x": 0.0006,
    "y": 0.4495,
    "w": 0.7494,
    "h": 0.3061
  },
  "strip": [
    0.7577,
    0.7768
  ],
  "floor": "#B69F7C",
  "ceiling": "#6C5E4A"
}
